import i18nFactory from '@yandex-int/i18n';

import {
    RetargetingConditionRule,
    RetargetingGoal,
    RetargetingStatus
} from '../../typings/domain';
import { GdRetargetingBaseStatusInput } from '../../typings/graphql-grid';
import { GdRetargetingConditionRuleType } from '../../typings/graphql-grid';
import { RetargetingConditionRuleType } from '../../typings/retargeting';

import * as keyset from './RetargetingHelpers.i18n';

const i18n = i18nFactory(keyset);

export function getRetargetingConditionTypeText(
    type: GdRetargetingConditionRuleType
): string {
    switch (type) {
        case GdRetargetingConditionRuleType.ALL:
            return i18n('condition-type-all');
        case GdRetargetingConditionRuleType.NOT:
            return i18n('condition-type-not');
        case GdRetargetingConditionRuleType.OR:
            return i18n('condition-type-or');
        default:
            throw Error(`unsupported Type ${type}`);
    }
}

export function getRetargetingStatusText(status: RetargetingStatus): string {
    switch (status) {
        case RetargetingStatus.active:
            return i18n('status-active');
        case RetargetingStatus.suspended:
        default:
            return i18n('status-stopped');
    }
}

export function getUnavailableGoalMessage(
    type: RetargetingConditionRuleType
): string {
    const notFoundValueTextDict = {
        [RetargetingConditionRuleType.METRIKA_GOAL_RULE]: i18n(
            'no-metrika-goal-value'
        ),
        [RetargetingConditionRuleType.METRIKA_SEGMENT_RULE]: i18n(
            'no-segment-value'
        ),
        [RetargetingConditionRuleType.AUDIENCE_SEGMENT_RULE]: i18n(
            'no-segment-value'
        )
    };
    return notFoundValueTextDict[type];
}

export const retargetingsCriteriaSetTitlesDictionary: Record<
    GdRetargetingBaseStatusInput,
    string
> = {
    [GdRetargetingBaseStatusInput.ACTIVE]: i18n('status-active'),
    [GdRetargetingBaseStatusInput.SUSPENDED]: i18n('status-stopped')
};

export function getRetargetingConditionsText(
    goals: Array<RetargetingGoal>
): string {
    const resultDescription = goals.map(goal => {
        if (goal.isUnavailable) {
            return getUnavailableGoalMessage(goal.type);
        }

        const domain = goal.domain !== undefined ? `${goal.domain} :: ` : '';
        const description = `${domain}${goal.name}`;

        return goal.time !== undefined
            ? `${description} (${i18n('day-description', {
                  count: goal.time
              })})`
            : description;
    });

    return resultDescription.join(', ');
}

export function getRetargetingConditions(
    conditionRules: Array<RetargetingConditionRule>,
    isCopyText: boolean
): string {
    const resultConditionRules = conditionRules.map(conditionItem => {
        const type = `${getRetargetingConditionTypeText(conditionItem.type)}:`;
        const description = getRetargetingConditionsText(conditionItem.goals);

        return `${type} ${description}.`;
    });

    return resultConditionRules.join(isCopyText ? '\n' : ' ');
}
